// extracted by mini-css-extract-plugin
export var masthead = "header-module--masthead--1N87p";
export var site_logo = "header-module--site_logo--3edgQ";
export var masthead_info = "header-module--masthead_info--1vT3-";
export var site_title = "header-module--site_title--4pGqH";
export var navigation = "header-module--navigation--2IUaJ";